module.exports = __webpack_public_path__ + "img/xiaolian.f2a67250.png";